import React from 'react'
import { POSTAPIError } from '../../types'
import { errors } from '../../constants/errors'
import { Link, useLocation } from 'react-router-dom'
import withModal from '../../utils/hoc/withModal'
import { AppDispatch } from '../../redux-stores/store'
import { useDispatch } from 'react-redux'
import { setIntendedPath } from '../../redux-stores/slices/layoutSlice'

interface GenericErrorsCTAModalProps {
    onClose: () => void,
    error: POSTAPIError
}

const GenericErrorsCTAModal: React.FC<GenericErrorsCTAModalProps> = ({ onClose, error }) => {
    const dispatch: AppDispatch = useDispatch();
    const location = useLocation();
    
    if(!error) return null;
    
    return (
        <React.Fragment>
            <div className="menu-title p-3">
                <h3 className="pop">
                    {errors[error.error_code]?.title ?? "Error"}
                </h3>
                <button onClick={onClose} className="close-menu font-16"><i className="fa fa-times-circle"></i></button>
            </div>
            <div className="card rounded-4 shadow-none border-0">
                <div className="card-body d-flex flex-column py-1">
                    {error.message ?? (errors[error.error_code]?.message ?? 'An error occurred.')}
                    {
                        errors[error.error_code]?.cta &&
                        <Link onClick={() => dispatch(setIntendedPath(location.pathname + location.search))} to={errors[error.error_code].cta?.url ?? '/'} className="btn btn-primary btn-sm rounded-4 mt-3">{errors[error.error_code]?.cta?.label}</Link>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

export default withModal(GenericErrorsCTAModal)